import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    cardContentPadding: {
      paddingLeft: '24px',
    },
  };
});

const listTextStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      textAlign: 'right',
    },

    primary: {
      color: theme.palette.secondary.dark,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: 600,
      textTransform: 'capitalize',
      textAlign: 'left',
      wordBreak: 'break-word',
    },
  };
});

const listItemsStyles = makeStyles((theme) => {
  return {
    root: {
      width: '100%',
      padding: '0 5px 8px',
      borderBottom: '1px solid #EEE',
      marginBottom: 10,
    },
  };
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      paddingLeft: 30,
      paddingRight: 30,
    },
  };
});

export { useStyles, listTextStyles, customCardStyles, listItemsStyles };
